









































import { Component, Vue } from 'vue-property-decorator';
import cart from '@/store/modules/cart';
import checkout from '@/store/modules/checkout';
import CartTotals from '@/components/Cart/Totals.vue';
import { CartItem as CartItemModel, QuoteAddress, Totals } from '../../store/models';

@Component({
    components: {
        CartTotals,
    },
})
export default class ReviewStep extends Vue {
    get items(): CartItemModel[] {
        return cart.cart.items;
    }

    get defaultShipping(): QuoteAddress {
        return checkout.defaultShippingAddress;
    }

    get totals(): Totals {
        return cart.totals;
    }
}
